import { Model, type } from "@type-r/models";

export abstract class FilterModel extends Model {
    static attributes = {
        isInitial : type(Boolean).value(false),
    };
    abstract delete();
    abstract asLabel();

    asTitle() {
        return this.asLabel();
    }
}
